import { requests } from '../index';
import URLS  from '../endPoints';
import request from 'superagent';

import axios from "axios"

let Documents = {}
// console.log('Documents', Documents)
//MG Api
Documents.uploadDocs = async (payload) => await requests.postHC("Recruiter/Applicants/UpploadDocument/", payload);
Documents.GetDocs = async (payload) => await requests.getHC(`Recruiter/Applicants/GetDocuments/${payload}`);
Documents.ViewDocument = async (payload) => await requests.getHC(`Recruiter/Applicants/ViewDocument/${payload}`);
export default Documents;